/**
 * Whether the reader's Vietnamese-gloss toggle is on, for the parent
 * (storybooks PRD amendment 2026-09-29 on Q4). Per device, not on the
 * account: a per-device convenience is what `localStorage` is for, and
 * losing it costs one tap.
 */

/** Where the preference lives. Namespaced so it cannot collide. */
const KEY = 'tutor.books.gloss';

/**
 * Off by default, and on a throw: a private window or blocked site data
 * must not make the toggle appear to have turned itself on, following
 * `audio/volume.ts`'s pattern of failing safe rather than loud.
 */
export function glossShown(): boolean {
  try {
    return globalThis.localStorage?.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Swallows a throw: the toggle still works this session, it just will not be remembered. */
export function setGlossShown(on: boolean): void {
  try {
    globalThis.localStorage?.setItem(KEY, on ? '1' : '0');
  } catch {
    // Site data blocked, or the quota is full -- not worth interrupting a
    // parent's reading over.
  }
}
